// REFERENCE OBJECTS
function ReferenceObjects(params, callback) {
    var typesToFetch = {};
    _.each(_.keys(params), function (key) {
        if (params[key] === true) {
            typesToFetch[key] = true;
        }
    });
    var refObjs = {};
    var refObjsGrouped = {};
    var refObjsIndexedById = {};

    // public accessors
    this.objs = function (key) {
        return refObjs[key];
    };

    this.objsGrouped = function (key) {
        return refObjsGrouped[key];
    };

    this.obj = function (key, id) {
        try {
            return refObjsIndexedById[key][id];
        } catch (e) {
            return null;
        }
    };

    // private fetch functions
    function permissionTypesFetched(types) {
        refObjs.permissionTypes = types;
        refObjsIndexedById.permissionTypes = _.indexBy(types, "id");
        delete typesToFetch.permissionTypes;
        checkIfComplete();
    }

    function libraryTypesFetched(libraryTypes) {
        refObjs.libraryTypes = libraryTypes;
        refObjsIndexedById.libraryTypes = _.indexBy(libraryTypes, "id");
        delete typesToFetch.libraryTypes;
        checkIfComplete();
    }

    function resultTypesFetched(resultTypes) {
        refObjs.resultTypes = resultTypes;
        refObjsIndexedById.resultTypes = _.indexBy(resultTypes, "id");
        delete typesToFetch.resultTypes;
        checkIfComplete();
    }

    function scoreCalcTypesFetched(scoreCalcTypes) {
        refObjs.scoreCalcTypes = scoreCalcTypes;
        refObjsIndexedById.scoreCalcTypes = _.indexBy(scoreCalcTypes, "id");
        delete typesToFetch.scoreCalcTypes;
        checkIfComplete();
    }

    function scoreboardSortDirectionsFetched(scoreboardSortTypes) {
        refObjs.scoreboardSortTypes = scoreboardSortTypes;
        refObjsIndexedById.scoreboardSortTypes = _.indexBy(
            scoreboardSortTypes,
            "id"
        );
        delete typesToFetch.scoreboardSortTypes;
        checkIfComplete();
    }

    function movementsFetched(moves) {
        refObjs.movements = moves;
        refObjsIndexedById.movements = _.indexBy(moves, "id");
        delete typesToFetch.movements;
        checkIfComplete();
    }

    function barbellLiftsFetched(data) {
        refObjs.barbellLifts = data.all;
        refObjsGrouped.barbellLifts = data.grouped;
        refObjsIndexedById.barbellLifts = _.indexBy(data.all, "id");
        delete typesToFetch.barbellLifts;
        checkIfComplete();
    }

    function gymBusinessTypesFetched(biz_types) {
        refObjs.gymBusinessTypes = biz_types;
        refObjsIndexedById.gymBusinessTypes = _.indexBy(biz_types, "id");
        delete typesToFetch.gymBusinessTypes;
        checkIfComplete();
    }

    function gymManagementPlatformsFetched(gmps) {
        refObjs.gymManagementPlatforms = gmps;
        refObjsIndexedById.gymManagementPlatforms = _.indexBy(gmps, "id");
        delete typesToFetch.gymManagementPlatforms;
        checkIfComplete();
    }

    function gymProgrammingSourcesFetched(prgSources) {
        refObjs.gymProgrammingSources = prgSources;
        refObjsIndexedById.gymProgrammingSources = _.indexBy(prgSources, "id");
        delete typesToFetch.gymProgrammingSources;
        checkIfComplete();
    }

    function gymCustomerCancelationReasonsFetched(reasons) {
        refObjs.gymCustomerCancelationReasons = reasons;
        refObjsIndexedById.gymCustomerCancelationReasons = _.indexBy(
            reasons,
            "id"
        );
        delete typesToFetch.gymCustomerCancelationReasons;
        checkIfComplete();
    }

    function trackTypesFetched(trackTypes) {
        refObjs.trackTypes = trackTypes;
        refObjsIndexedById.trackTypes = _.indexBy(trackTypes, "id");
        delete typesToFetch.trackTypes;
        checkIfComplete();
    }

    function trackTimelineTypesFetched(trackTimelineTypes) {
        refObjs.trackTimelineTypes = trackTimelineTypes;
        refObjsIndexedById.trackTimelineTypes = _.indexBy(
            trackTimelineTypes,
            "id"
        );
        delete typesToFetch.trackTimelineTypes;
        checkIfComplete();
    }

    function remoteProvidersFetched(providers) {
        refObjs.remoteIntegrationProviders = providers;
        refObjsIndexedById.remoteIntegrationProviders = _.indexBy(
            providers,
            "id"
        );
        delete typesToFetch.remoteIntegrationProviders;
        checkIfComplete();
    }

    function taxonomyCategoriesFetched(categories) {
        refObjs.marketplaceProductTaxonomy = categories;
        refObjsIndexedById.marketplaceProductTaxonomy = _.indexBy(
            categories,
            "id"
        );
        delete typesToFetch.marketplaceProductTaxonomy;
        checkIfComplete();
    }

    function checkIfComplete() {
        if (_.keys(typesToFetch).length === 0) {
            callback(refObjs);
        }
    }

    // fetch the requested types
    if (typesToFetch.permissionTypes === true) {
        fetchPermissionTypes(null, permissionTypesFetched);
    }

    if (typesToFetch.resultTypes === true) {
        fetchResultTypes(null, resultTypesFetched);
    }

    if (typesToFetch.scoreCalcTypes === true) {
        fetchScoreCalcTypes(null, scoreCalcTypesFetched);
    }

    if (typesToFetch.scoreboardSortTypes === true) {
        fetchScoreboardSortDirections(null, scoreboardSortDirectionsFetched);
    }

    if (typesToFetch.movements === true) {
        fetchMovements(null, movementsFetched);
    }

    if (typesToFetch.libraryTypes === true) {
        fetchLibraryTypes(null, libraryTypesFetched);
    }

    if (typesToFetch.barbellLifts === true) {
        fetchBarbellLifts(null, function (bbls) {
            fetchAffiliateBarbellLifts(null, function (affBBLs) {
                if (affBBLs.length > 0) {
                    bbls.all = _.union(bbls.all, affBBLs);
                    bbls.grouped.push({
                        typeName: "Gym Barbell Lifts",
                        bbls: affBBLs,
                    });
                }
                barbellLiftsFetched(bbls);
            });
        });
    }

    if (typesToFetch.gymBusinessTypes === true) {
        fetchGymBusinessTypes(null, gymBusinessTypesFetched);
    }

    if (typesToFetch.gymManagementPlatforms === true) {
        fetchGymManagementPlatforms(null, gymManagementPlatformsFetched);
    }

    if (typesToFetch.gymProgrammingSources === true) {
        fetchGymProgrammingSources(null, gymProgrammingSourcesFetched);
    }

    if (typesToFetch.gymCustomerCancelationReasons === true) {
        fetchGymCustomerCancelReasons(
            null,
            gymCustomerCancelationReasonsFetched
        );
    }

    if (typesToFetch.trackTypes === true) {
        fetchTrackTypes(null, trackTypesFetched);
    }

    if (typesToFetch.trackTimelineTypes === true) {
        fetchTrackTimelineTypes(null, trackTimelineTypesFetched);
    }

    if (typesToFetch.remoteIntegrationProviders === true) {
        fetchRemoteIntegrationProviders(null, remoteProvidersFetched);
    }

    if (typesToFetch.marketplaceProductTaxonomy === true) {
        fetchProductTaxonomyCategories(null, taxonomyCategoriesFetched);
    }
}

function fetchPermissionTypes(params, successFn, errorFn) {
    var url = "/api/permissiontypes";
    var data = params || {};
    getObjects(url, data, "Fetching permission types", successFn, errorFn);
}

function fetchLibraryWorkouts(params, successFn, errorFn) {
    var LIBRARY_TYPE_STRINGS = [
        "Barbell Lifts",
        "Endurance",
        "Gymnastics",
        "Girls",
        "Heroes",
        "Notables",
        "Games",
        "Custom",
    ];
    var url =
        "/api/library/categories/" + LIBRARY_TYPE_STRINGS[params.libraryType];
    var data = params || {};
    getObjects(url, data, "Fetching library workouts", successFn, errorFn);
}

function fetchMovements(params, successFn, errorFn) {
    var url = "/public/api/v1/movements/";
    var data = params || {};
    getObjects(url, data, "Fetching movements", successFn, errorFn);
}

function fetchLibraryTypes(params, successFn, errorFn) {
    var url = "/api/librarytypes";
    var data = params || {};
    getObjects(url, data, "Fetching library types", successFn, errorFn);
}

function fetchResultTypes(params, successFn, errorFn) {
    var url = "/api/resulttypes";
    var data = params || {};
    getObjects(url, data, "Fetching result types", successFn, errorFn);
}

function fetchScoreCalcTypes(params, successFn, errorFn) {
    var url = "/api/score-calc-types";
    var data = params || {};
    getObjects(url, data, "Fetching scorecalc types", successFn, errorFn);
}

function fetchScoreboardSortDirections(params, successFn, errorFn) {
    var url = "/api/scoreboard-sort-types";
    var data = params || {};
    getObjects(url, data, "Fetching scoreboarf sort types", successFn, errorFn);
}

function fetchTrackTypes(params, successFn, errorFn) {
    var url = "/api/tracktypes";
    var data = params || {};
    getObjects(url, data, "Fetching track types", successFn, errorFn);
}

function fetchTrackTimelineTypes(params, successFn, errorFn) {
    var url = "/api/tracktimelinetypes";
    var data = params || {};
    getObjects(url, data, "Fetching track timeline types", successFn, errorFn);
}

function fetchRemoteIntegrationProviders(params, successFn, errorFn) {
    var url = "/api/remote-integration-providers";
    var data = params || {};
    getObjects(url, data, "Fetching providers", successFn, errorFn);
}

function fetchProductTaxonomyCategories(params, successFn, errorFn) {
    var url = "/public/api/v1/marketplace-product-taxonomy-categories";
    var data = params || {};
    getObjects(url, data, "Fetching categories", successFn, errorFn);
}

function findMentionedMovements(fetchedMovements, workoutStr) {
    // returns the movementIds of the movements found in the workout

    var words = _.uniq(
        workoutStr.trim().toLowerCase().replace(/\s+/g, " ").split(" ")
    );
    var stringToScan = _.reduce(
        words,
        function (memo, word) {
            return memo + word;
        },
        ""
    );

    var movementsMentioned = [];

    _.each(fetchedMovements, function (move) {
        _.each(move.searchTerms, function (searchTerm) {
            if (stringToScan.indexOf(searchTerm) !== -1) {
                // found it!
                movementsMentioned.push(move);
            }
        });
    });

    var movementsMentionedIds = _.uniq(
        _.map(movementsMentioned, function (move) {
            return move.id;
        })
    );

    return movementsMentionedIds;
}

function fetchGymManagementPlatforms(params, successFn, errorFn) {
    var url = "/api/gymmanagementplatforms";
    var data = params || {};
    getObjects(
        url,
        data,
        "Fetching gym management platforms",
        successFn,
        errorFn
    );
}

function fetchGymBusinessTypes(params, successFn, errorFn) {
    var url = "/api/gymbusinesstypes";
    var data = params || {};
    getObjects(url, data, "Fetching gym business types", successFn, errorFn);
}

function fetchGymCustomerCancelReasons(params, successFn, errorFn) {
    var url = "/api/customer-cancel-reasons";
    var data = params || {};
    getObjects(url, data, "Fetching reasons", successFn, errorFn);
}

function fetchGymProgrammingSources(params, successFn, errorFn) {
    var url = "/api/gymprogrammingsources";
    var data = params || {};
    getObjects(
        url,
        data,
        "Fetching gym programming sources",
        successFn,
        errorFn
    );
}

module.exports = {
    ReferenceObjects: ReferenceObjects,
    fetchPermissionTypes: fetchPermissionTypes,
    fetchLibraryWorkouts: fetchLibraryWorkouts,
    fetchMovements: fetchMovements,
    fetchLibraryTypes: fetchLibraryTypes,
    fetchResultTypes: fetchResultTypes,
    fetchScoreCalcTypes: fetchScoreCalcTypes,
    fetchScoreboardSortDirections: fetchScoreboardSortDirections,
    fetchTrackTypes: fetchTrackTypes,
    fetchTrackTimelineTypes: fetchTrackTimelineTypes,
    fetchRemoteIntegrationProviders: fetchRemoteIntegrationProviders,
    fetchProductTaxonomyCategories: fetchProductTaxonomyCategories,
    findMentionedMovements: findMentionedMovements,
    fetchGymManagementPlatforms: fetchGymManagementPlatforms,
    fetchGymBusinessTypes: fetchGymBusinessTypes,
    fetchGymCustomerCancelReasons: fetchGymCustomerCancelReasons,
    fetchGymProgrammingSources: fetchGymProgrammingSources,
};
